export default {
  install(Vue) {
    Vue.prototype.get_salary_type = async function() {
      const api = `${window.endpoints.api}/BasicInformation/SalaryType`;
      const params = { IsEnable: true };

      const response = await this.$http.get(api, { params });
      const sorted = response.data.sort((a, b) => a.Seq - b.Seq);

      return sorted.map(({ Code, Guid, Name }) => ({
        Code,
        Guid,
        Name
      }));
    };
  },
};